export const capitalize = (value: string) => {
  return value?.length > 0 ? value[0].toUpperCase() + value.slice(1) : ''
}

export const uppercase = (value: string) => value.toUpperCase()
